import React from 'react';
import InputBox from '../../components/InputBox';
import Button from '../../components/Button';

/** Setup screen — candidate enters Session ID + Candidate ID to begin. */
const AIInterviewSetup = ({
  sessionId, candidateId, setSessionId, setCandidateId, onStart, onViewHistory, loading,
}) => (
  <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-8">
    <div className="text-center mb-6">
      <h2 className="text-lg font-semibold text-slate-800 dark:text-white">Start your interview</h2>
      <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
        Enter your details below and we'll get started.
      </p>
    </div>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onStart();
      }}
      className="space-y-4"
    >
      <InputBox
        label="Session ID"
        value={sessionId}
        onChange={(e) => setSessionId(e.target.value)}
        placeholder="session_..."
        disabled={loading}
      />
      <InputBox
        label="Candidate ID"
        value={candidateId}
        onChange={(e) => setCandidateId(e.target.value)}
        placeholder="e.g. 4775"
        disabled={loading}
      />
      <div className="pt-2">
        <Button type="submit" variant="primary" size="lg" fullWidth loading={loading} disabled={loading}>
          {loading ? 'Preparing your interview…' : 'Start Interview'}
        </Button>
      </div>
    </form>
    {onViewHistory && (
      <button
        type="button"
        onClick={onViewHistory}
        disabled={loading}
        className="mt-3 w-full text-sm text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-300 disabled:opacity-50 transition"
      >
        View past interview results
      </button>
    )}
  </div>
);

export default AIInterviewSetup;
